import { StoredValueExpirationTable } from './stored-value-expiration-table.component';

import { useStoredValueExpirationSchedule } from '../../../data-access/queries';

type StoredValueExpirationProps = {
  memberId: string;
};

export const StoredValueExpirationComponent = (props: StoredValueExpirationProps) => {
  const { memberId } = props;
  const { loading, error, data, paginationProps } = useStoredValueExpirationSchedule({
    memberId,
  });

  return (
    <StoredValueExpirationTable
      rows={data}
      paginationProps={paginationProps}
      loading={loading}
      error={error}
    />
  );
};
